import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import { EventApiResponseType } from "./typings/EventApiResponseType";

export default class EventService {
  static async getEventsbyMedicalEmergencyId(medicalEmergencyId: number) {
    const apiConfig = {
      api: APIs.Events.GetEvents,
      parameters: {
        "medical-emergency-id": medicalEmergencyId.toString(),
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as EventApiResponseType[];
  }
}
